export const translationEngDefault = {
  SkhemataBlogList: {
    showMoreButton: 'Show More...',
    tags: 'Tags',
    categories: 'Categories',
  }
};
